import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import React from 'react';

import MaxAndMediumScreen from '@/components/Device/MaxAndMediumScreen';
import SmallScreen from '@/components/Device/SmallScreen';
import Title from '@/components/Title';

import Countries from './Countries';
import Trustpilot from './Trustpilot';

const Kids = dynamic(import('./Kids'), { ssr: false });

const Family: React.FC = () => {
  const { t } = useTranslation(['whyWukong']);

  return (
    <div className="relative flex justify-center pb-[40px] pt-[136px] lg:pt-[144px] xl:pt-[209px]">
      <Image
        src="/images/reasonsForChoosing/family_bg.svg"
        alt="家庭背景"
        fill
        loading="eager"
        priority
        className="z-[-1] hidden object-cover object-center lg:block xl:block"
      />
      <Image
        src="/images/reasonsForChoosing/family_bg_small.svg"
        alt="家庭背景移动版"
        fill
        priority
        loading="eager"
        className="z-[-1] block object-cover object-center lg:hidden xl:hidden"
      />
      <div className="max-w-[100vw] lg:container xl:container">
        <div className="px-5">
          <MaxAndMediumScreen>
            <Title className="" innerHTML theme="colorful" htmlLabel="h1">
              {t('理由-见证孩子可能')}
            </Title>
          </MaxAndMediumScreen>
          <SmallScreen>
            <Title className="" innerHTML theme="colorful" htmlLabel="h1">
              {t('理由-见证孩子可能-small')}
            </Title>
          </SmallScreen>
        </div>
        <Kids />
        <div className="px-5">
          <Countries />
          <Trustpilot />
        </div>
      </div>
    </div>
  );
};

export default Family;
